export default "__VITE_ASSET__BbV$PQMR__"